import styles from './MessagesList.module.css';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useMemo, useRef } from 'react';
import { motion } from 'motion/react';

import confetti from '../../assets/video/confetti.webm';
import logo from '../../assets/images/logo.png';

export const MessagesList = ({
  messages,
  authorFontSize,
  currentState,
  winId,
  speed,
}) => {
  const confettiRef = useRef(null);

  const isWinner = useMemo(() => currentState === 'S6', [currentState]);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current && isWinner) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 1500);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [isWinner]);

  const letters = 'ПОБЕДИТЕЛЬ!'.split('').reverse();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={styles['wrapper']}
    >
      <img src={logo} alt="logo" className={styles.logo} />

      <div className={styles.firstLine} dir="rtl">
        {isWinner &&
          letters.map((l, idx, arr) => {
            let initialIdx = 4;
            let oneLetterWidth = 10;
            let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

            return (
              <motion.div
                style={{ position: 'relative', zIndex: idx * -1 }}
                key={l + idx}
                initial={{
                  scale: 0,
                  opacity: 0,
                  x: initialX,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                  x: 0,
                }}
                transition={{
                  duration: 0.4,
                  delay: idx * 0.1 + 2,
                }}
              >
                {l}
              </motion.div>
            );
          })}
      </div>

      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages.length > 0 &&
            messages.map((item, i) => (
              <CSSTransition
                key={item.UUID}
                timeout={speed}
                classNames="position"
              >
                <Message
                  winId={winId}
                  key={item.id}
                  message={item.message}
                  titrTag={item.titrTag}
                  authorFontSize={authorFontSize}
                  currentState={currentState}
                />
              </CSSTransition>
            ))}
        </TransitionGroup>
      </div>

      {isWinner && (
        <video
          ref={confettiRef}
          muted="muted"
          loop
          playsInline
          className={styles.confetti}
        >
          <source src={confetti} type="video/webm"></source>
        </video>
      )}
    </motion.div>
  );
};
